import * as React from 'react'

function StatsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
      <g
        stroke={props.color ?? '#898989'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        clipPath="url(#a)"
      >
        <path d="M21 19.5H3v-15" />
        <path d="M18.75 6.75 12 13.5l-3-3-6 6" />
        <path d="M18.75 10.5V6.75H15" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
export default StatsIcon
